import React from 'react';
import { useErrorReporting } from '../hooks/useErrorReporting';

/**
 * Component that sets up error reporting with user information
 * This is a "silent" component that doesn't render anything visible
 */
const ErrorReportingProvider = () => {
  // Use the error reporting hook to update user information
  useErrorReporting();

  // This component doesn't render anything
  return null;
};

export default ErrorReportingProvider;
